
export const LongCard = ({ imageUrl, imageAlt, headerText, content, url }) => {
	if (url) {
		return (
			<a href={url}>
				<CardContent imageAlt={imageAlt} imageUrl={imageUrl} headerText={headerText} content={content} />
			</a>
		);
	}
	return <CardContent imageAlt={imageAlt} imageUrl={imageUrl} headerText={headerText} content={content} />;
};

const CardContent = ({ imageAlt, imageUrl, headerText, content }) => {
	return (
		<div className={`flex flex-row gap-4 w-full m-w-[200px] justify-start bg-is2-blue py-6 px-4 rounded-lg`}>
			<img src={imageUrl} alt={imageAlt} className="w-[40px] h-[40px]" />
			<div className="flex flex-col gap-1 justify-start">
				<h6 className="text-md font-bold my-0 text-left text-white">{headerText}</h6>
				<div className="md:block [&>p]:text-left [&_p]:text-is2-blue-100 [&_p]:text-sm">{content}</div>
			</div>
		</div>
	);
};
